import {all, takeEvery, put, fork, call} from 'redux-saga/effects';
import {
    AUTH_TOKEN,
    SIGNIN,
    SIGNOUT,
    SIGNUP,
    SIGNIN_WITH_GOOGLE,
    SIGNIN_WITH_FACEBOOK, AUTH_HEADERS, AUTH_CREDENTIALS, USER_DATA
} from '../constants/Auth';
import {
    showAuthMessage,
    authenticated,
    signOutSuccess,
    signUpSuccess,
    signInWithGoogleAuthenticated,
    signInWithFacebookAuthenticated
} from "../actions/Auth";

import FirebaseService from 'services/FirebaseService'
import JwtAuthService from "../../services/JwtAuthService";

export function* signInWithEmail() {
    yield takeEvery(SIGNIN, function* ({payload}) {
        try {
            const response = yield call(JwtAuthService.login, payload);
            const {result} = response.data;

            const auth_cred = {
                [AUTH_HEADERS.TOKEN]: result[AUTH_HEADERS.TOKEN],
            }

            localStorage.setItem(AUTH_CREDENTIALS, JSON.stringify(auth_cred));
            localStorage.setItem(USER_DATA, JSON.stringify(result.user));

            yield put(authenticated({user: result.user, auth_credentials: auth_cred}));

        } catch (err) {
            if (err.response && err.response.data) {
                yield put(showAuthMessage(err.response.data.message));
            } else {
                yield put(showAuthMessage("Ha ocurrido un error inesperado"));
            }
        }
    });
}

export function* signOut() {
    yield takeEvery(SIGNOUT, function* () {
        try {
            localStorage.removeItem(AUTH_CREDENTIALS);
            localStorage.removeItem(USER_DATA);
            yield put(signOutSuccess());
        } catch (err) {
            yield put(showAuthMessage(err.response.data.message));
        }
    });
}

export function* signUpWithFBEmail() {
    yield takeEvery(SIGNUP, function* ({payload}) {
            const {email, password} = payload;
            try {
                const user = yield call(FirebaseService.signUpEmailRequest, email, password);
                if (user.message) {
                    yield put(showAuthMessage(user.message));
                } else {
                    localStorage.setItem(AUTH_TOKEN, user.user.uid);
                    yield put(signUpSuccess(user.user.uid));
                }
            } catch (error) {
                yield put(showAuthMessage(error));
            }
        }
    );
}

export function* signInWithFBGoogle() {
    yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
        try {
            const user = yield call(FirebaseService.signInGoogleRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithGoogleAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export function* signInWithFacebook() {
    yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
        try {
            const user = yield call(FirebaseService.signInFacebookRequest);
            if (user.message) {
                yield put(showAuthMessage(user.message));
            } else {
                localStorage.setItem(AUTH_TOKEN, user.user.uid);
                yield put(signInWithFacebookAuthenticated(user.user.uid));
            }
        } catch (error) {
            yield put(showAuthMessage(error));
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(signInWithEmail),
        fork(signOut),
        fork(signUpWithFBEmail),
        fork(signInWithFBGoogle),
        fork(signInWithFacebook)
    ]);
}
